import React, { type FC } from 'react';

export const Frames: FC = () => {
    const framesImage = new URL('./frames.png', import.meta.url).toString();
    return (
        <div className="text-white flex flex-col gap-4 pb-2">
            <p className="text-2xl">Frames</p>
            <p>
                Each SVG file you upload to your template creates a new Frame. Frames can contain style variations of
                the same design, size variations, or multiple design options within a single template that has similar
                content.
            </p>
            <img src={framesImage} alt="frames" />
            <p>
                Frames can be created by importing SVG files generated from any design tool like Figma, or Adobe Suite.
            </p>
        </div>
    );
};
